import React, { Component } from "react"
import { Row, Col } from "reactstrap"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <div className="container-fluid">
            <Row>
              <Col sm={6}>File Handler Viewer © {new Date().getFullYear()} </Col>
              <Col sm={6}>
                <div className="text-sm-end d-none d-sm-block">
                  Developped by CGOS
              </div>
              </Col>
            </Row>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

export default Footer;